"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const S = __importStar(require("./ProgressIndicator.styles"));
const ProgressCircle = ({ radius, stroke, progress }) => (react_1.default.createElement(react_native_svg_1.Svg, { height: radius * 2, width: radius * 2 },
    react_1.default.createElement(react_native_svg_1.Defs, null,
        react_1.default.createElement(react_native_svg_1.LinearGradient, { id: "progressColors", x1: "0%", y1: "0%", x2: "100%", y2: "0%" },
            react_1.default.createElement(react_native_svg_1.Stop, { offset: "0%", stopColor: "#15d4d0" }),
            react_1.default.createElement(react_native_svg_1.Stop, { offset: "100%", stopColor: "#7cf249" }))),
    react_1.default.createElement(react_native_svg_1.Circle, { stroke: "#ddd", fill: "none", strokeWidth: stroke, r: radius - stroke / 2, cx: "50%", cy: "50%" }),
    react_1.default.createElement(react_native_svg_1.G, { transform: `rotate(-90 ${radius} ${radius})` },
        react_1.default.createElement(react_native_svg_1.Circle, { stroke: "url(#progressColors)", fill: "none", strokeWidth: stroke, strokeDasharray: 2 * Math.PI * (radius - stroke / 2), r: radius - stroke / 2, cx: "50%", cy: "50%", strokeDashoffset: 2 * Math.PI * (radius - stroke / 2) * (1 - progress) }))));
const ProgressIndicator = ({ currentStep, totalSteps, radius = 28, stroke = 8, fontSize = 14, }) => (react_1.default.createElement(S.Wrapper, { size: 2 * radius },
    react_1.default.createElement(S.ProgressCircleWrapper, null,
        react_1.default.createElement(ProgressCircle, { radius: radius, stroke: stroke, progress: currentStep / totalSteps })),
    react_1.default.createElement(S.Content, { fontSize: fontSize }, `${currentStep}/${totalSteps}`)));
exports.default = ProgressIndicator;
